<template>
  <v-layout>
    <!-- 로그인 모달 -->
    <v-dialog
      v-model="auth.modal.login"
      max-width="360"
    >
      <v-form ref="auth_form" class="row wrap login-box" @keyup.native.enter="submitLogin" lazy-validation>
        <div class="login-close" @click="auth.modal.login = false"><v-icon>close</v-icon></div>
        <v-flex class="login-title">로그인</v-flex>
        <v-flex class="login-from mt-3">
          <v-flex>
            <v-text-field
              v-model="login.id"
              label="이메일"
              :rules="rules.email"
            ></v-text-field>
          </v-flex>
          <v-flex>
            <v-text-field
              v-model="login.pw"
              label="비밀번호"
              :append-icon="login.passShow ? 'visibility' : 'visibility_off'"
              :type="login.passShow ? 'text' : 'password'"
              :rules="rules.pw"
              counter
              @click:append="login.passShow = !login.passShow"
            ></v-text-field>
          </v-flex>
          <v-layout>
            <v-flex>
              <v-checkbox
                v-model="login.saveId"
                label="이메일저장"
                color="title_dark1"
                @change="btnIdSave"
              ></v-checkbox>
            </v-flex>
            <v-flex style="text-align: right;">
              <!--<div style="margin-top:20px; font-size: 16px; color: rgba(0,0,0,.54); cursor: pointer;" @click="showPasswordLost()">비밀번호찾기</div>-->
            </v-flex>
          </v-layout>
          <v-flex>
            <v-btn block color="title_dark1" style="height: 46px;" :loading="login.loading" :disabled="login.loading"  @click="submitLogin">
              <span style="color:#fff; font-size: 16px;">로그인</span>
            </v-btn>
          </v-flex>
          <v-layout>
            <v-flex>
              <v-btn block color="#fae100" dark style="height: 46px;" @click="move(getBaseUrl() + '/bbs/login.php?provider=kakao&url=' + getEncodeLocUrl())"><span style="color:#3b1e1e">카카오로 로그인</span></v-btn>
            </v-flex>
            <v-flex style="text-align: right; margin-left:12px;">
              <v-btn block color="#00ce5f" dark style="height: 46px;" @click="move(getBaseUrl() + '/bbs/login.php?provider=naver&url=' + getEncodeLocUrl())">네이버로 로그인</v-btn>
            </v-flex>
          </v-layout>
          <!--<v-flex class="join-text">
            간편하게 이메일로 <a :href="getBaseUrl() + '/bbs/register'" class="point">회원가입!</a>
          </v-flex>-->
        </v-flex>
      </v-form>
    </v-dialog>
  </v-layout>
</template>

<script>
import Utile from '@/utile/utile'
import { mapState, mapActions, mapMutations } from 'vuex'
import EventBus from '@/utile/eventBus'

export default {
  name: 'Auth',
  data: () => ({
    login: {
      passShow: false,
      saveId: false,
      id: '',
      pw: '',
      loading: false,
      btnColor: 'title_dark1'
    },
    rules: {
      email: [
        v => !!v || '이메일을 입력 해주세요.'
        // v => (v && v.length <= 10) || 'Name must be less than 10 characters'
      ],
      pw: [
        v => !!v || '패스워드를 입력 해주세요.'
        // v => (v && v.length <= 10) || 'Name must be less than 10 characters'
      ]
    }
  }),
  mounted () {
    // 아이디 저장이라면
    if (localStorage.getItem('saveId') === '1') {
      this.login.saveId = true
      this.login.id = localStorage.getItem('login_id')
    }
    // 토근 상태 감시
    this.$store.watch(() => this.auth.token, (newValue, oldValue) => {
      // console.log(`token:` + this.auth.token)
      if (oldValue !== newValue) { // 상태변화
        if (newValue === 'null') { // 로그아웃
          this.logoutProcessing() // 로그아웃 기타 처리
        } else if (newValue !== '') { // 로그인 상태변화로 인한 회원 정보 재로드 (초기로드 제외)
          this.updateMemberData()
          this.loginProcessing() // 로그인 기타 처리
        }
      }
    })
    // 회원정보 로드
    this.updateMemberData()
  },
  components: {
  },
  computed: {
    ...mapState({
      auth: state => state.auth,
      mapData: state => state.mapData
    })
  },
  methods: {
    ...mapActions({
      requestAuthData: 'auth/requestAuthData'
    }),
    ...mapMutations({
      logout: 'auth/logout',
      setMember: 'auth/setMember'
    }),
    // 로그인 처리
    loginProcessing () {
      // 창 초기화
      EventBus.$emit('reloadDetail')
      // 맵 확대 범위
      EventBus.$emit('resetMapMinLevel')
      EventBus.$emit('updateMap', 'login')
    },
    // 로그아웃 처리
    logoutProcessing () {
      this.logout()
      // 창종료
      EventBus.$emit('reloadDetail')
      this.mapData.modifView.show = false
      // 맵 확대 범위
      EventBus.$emit('resetMapMinLevel')
      EventBus.$emit('updateMap', 'logout')
    },
    move (url) {
      window.location.href = url
    },
    showPasswordLost () {
      window.open(this.getBaseUrl() + '/bbs/password_lost', 'win_password_lost', 'left=50, top=50, width=617, height=330, scrollbars=1')
    },
    getEncodeLocUrl () {
      return encodeURIComponent(this.$utile.getBaseUrl())
    },
    getBaseUrl () {
      return Utile.getBaseUrl()
    },
    updateMemberData () {
      this.requestAuthData({'type': 'authData'}).then((data) => {
        if (data.array.rcode === '1') { // 정상로드
          // 회원정보 적용
          this.setMember(data.array)
          this.loginProcessing()
        } else if (data.array.rcode === '0') { // 오류
          this.auth.token = ''
          // console.log('log: login-err')
        }
      })
    },
    submitLogin () {
      if (!this.login.loading) {
        if (this.$refs.auth_form.validate()) { // 룰에 어긋나지 않는다면
          this.login.loading = true

          this.requestAuthData({'type': 'login', 'id': this.login.id, 'pw': this.login.pw}).then((data) => {
            if (data.array.rcode === '1') {
              this.auth.modal.login = false // 로그인창 종료
            } else if (data.array.rcode === '0') {
              EventBus.$emit('alert', data.array.msg)
            }

            if (this.login.saveId) {
              localStorage.setItem('login_id', this.login.id)
            } else {
              this.login.id = ''
            }
            this.login.pw = ''
            this.login.loading = false
          }).catch((err) => {
            console.log(err)
            this.login.loading = false
          })
        }
      }
    },
    btnIdSave () {
      if (this.login.saveId) {
        localStorage.setItem('saveId', '1')
      } else {
        localStorage.setItem('saveId', '0')
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
  }
  @-moz-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-webkit-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-o-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/modal/Auth.vue